import { Box, Card, CardContent } from "@mui/material";
import { useEffect, useState } from "react";
import localize from "../../common/localize";
import ScrollablePageTab from "../dynamicForm/components/ScrollablePageTab";
import { TabContext, TabPanel } from "@mui/lab";
import MyRequests from "./components/MyRequests";
import RequestsAssignedToMe from "./components/RequestsAssignedToMe";
import PageTitleSubtitle from "../../components/PageTitleSubTitle";
import FilterWithPrinter from "../../components/common/FilterWithPrinter";
import {
  getGeneralRequestFilteringOptions,
  getUserName,
  getUserPersonalId,
} from "../../common/EntitiesManagement";
import EntityPrinter from "../../components/common/EntityPrinter";
import { getFiltersInfo } from "../../common/utils";
import useGlobalContext from "../../hooks/useGlobalContext";

export default function GeneralRequests() {
  const { GENERAL_REQUESTS_ENDPOINT } = useGlobalContext();
  const [selectedTab, setSelectedTab] = useState("0");
  const filterOptions = getGeneralRequestFilteringOptions();
  const [filters, setFilters] = useState([filterOptions[1]]);
  const [showPrinterModal, setShowPrinterModal] = useState(false);

  useEffect(() => {
    if (!filters || filters?.length === 0) {
      setFilters([filterOptions[1]]);
    }
  }, [filters]);

  const changeTab = (value) => {
    value >= 0 && setSelectedTab(value.toString());
  };

  const getTabPages = () => {
    const result = [
      {
        Id: "0",
        Name: localize.my_requests,
      },
      {
        Id: "1",
        Name: localize.requests_assigned_to_me,
      },
    ];

    return result;
  };

  const showPrinter = () => {
    setShowPrinterModal(true);
  };

  const getColumnTitles = () => {
    if (selectedTab === "0") {
      return [
        localize.type,
        localize.status,
        localize.event,
        localize.client,
        localize.assigned_to,
        localize.expected_attention_date,
        localize.creation_date,
      ];
    }

    return [
      localize.type,
      localize.status,
      localize.event,
      localize.client,
      localize.expected_attention_date,
      localize.creation_date,
      localize.created_by,
    ];
  };

  const getObjectType = () => {
    if (selectedTab === "0") {
      return "my_requests";
    }

    return "requests_assigned_to_me";
  };

  const getEndpoint = () => {
    if (selectedTab === "0") {
      return `${GENERAL_REQUESTS_ENDPOINT}/${getUserName()}`;
    }

    return `${GENERAL_REQUESTS_ENDPOINT}/personal/${getUserPersonalId()}`;
  };

  return (
    <div className="lateral_padding">
      {showPrinterModal && (
        <EntityPrinter
          closeCallback={() => setShowPrinterModal(false)}
          title={localize.print}
          report_title={`${localize.general_requests} - ${
            getTabPages().find((x) => x.Id === selectedTab).Name
          }`}
          report_subtitle={getFiltersInfo(filters)}
          url={getEndpoint()}
          filters={filters ?? []}
          columns={getColumnTitles()}
          objectTypeName={getObjectType()}
        />
      )}

      <div className="flex flex-col">
        <Card
          variant="outlined"
          style={{
            margin: "16px",
            boxShadow:
              "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
          }}
        >
          <CardContent>
            <Box className="flex flex-col gap-2 w-full">
              <PageTitleSubtitle
                title={localize.general_requests}
                subtitle={localize.general_requests_subtitle}
                useEventTitleStyle
              />

              <FilterWithPrinter
                filterItemName={"general_requests"}
                filterOptionsValue={filterOptions}
                filterDataValue={filters}
                setFilterDataValue={setFilters}
                defaultFiltering={filterOptions[1]}
                printButtonMethod={showPrinter}
              />
            </Box>
          </CardContent>
        </Card>
        <TabContext value={selectedTab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <ScrollablePageTab
              selectedPage={parseInt(selectedTab)}
              setSelectedPage={changeTab}
              noMarginTop
              dynamicFormPages={getTabPages()}
            />
          </Box>

          <TabPanel value="0" index={0}>
            <MyRequests filters={filters} />
          </TabPanel>
          <TabPanel value="1" index={1}>
            <RequestsAssignedToMe filters={filters} />
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
}
